<div class="ngx-gallery-layout {{ currentOptions?.layout }}">
  <ngx-gallery-thumbnails
    *ngIf="currentOptions?.thumbnails"
    [style.marginTop]="getThumbnailsMarginTop()"
    [style.marginBottom]="getThumbnailsMarginBottom()"
    [style.height]="getThumbnailsHeight()"
    [images]="smallImages"
    [links]="currentOptions?.thumbnailsAsLinks ? links : []"
    [linkTarget]="currentOptions?.linkTarget"
    [selectedIndex]="selectedIndex"
    [selectedBorderStyle]="currentOptions?.thumbnailSelectedBorderStyle"
    [columns]="currentOptions?.thumbnailsColumns"
    [rows]="currentOptions?.thumbnailsRows"
    [margin]="currentOptions?.thumbnailMargin"
    [arrows]="currentOptions?.thumbnailsArrows"
    [arrowsAutoHide]="currentOptions?.thumbnailsArrowsAutoHide"
    [arrowPrevIcon]="currentOptions?.arrowPrevIcon"
    [arrowNextIcon]="currentOptions?.arrowNextIcon"
    [clickable]="currentOptions?.image || currentOptions?.preview"
    [swipe]="currentOptions?.thumbnailsSwipe"
    [size]="currentOptions?.thumbnailSize"
    [moveSize]="currentOptions?.thumbnailsMoveSize"
    [order]="currentOptions?.thumbnailsOrder"
    [remainingCount]="currentOptions?.thumbnailsRemainingCount"
    [lazyLoading]="currentOptions?.lazyLoading"
    [actions]="currentOptions?.thumbnailActions"
    [showPreviewOnAction]="currentOptions?.thumbnailShowPreviewOnAction"
    (onActiveChange)="selectFromThumbnails($event)"
    (onShowPreview)="showPreviewFromThumbnail($event)"
    [showDownloadOnAction]="currentOptions?.thumbnailShowDownload"
    (onDownload)="download($event)"
  ></ngx-gallery-thumbnails>

  <ngx-gallery-preview
    [images]="bigImages"
    [showDescription]="currentOptions?.previewDescription"
    [arrowPrevIcon]="currentOptions?.arrowPrevIcon"
    [arrowNextIcon]="currentOptions?.arrowNextIcon"
    [closeIcon]="currentOptions?.closeIcon"
    [fullscreenIcon]="currentOptions?.fullscreenIcon"
    [spinnerIcon]="currentOptions?.spinnerIcon"
    [swipe]="currentOptions?.previewSwipe"
    [fullscreen]="currentOptions?.previewFullscreen"
    [forceFullscreen]="currentOptions?.previewForceFullscreen"
    [closeOnClick]="currentOptions?.previewCloseOnClick"
    [closeOnEsc]="currentOptions?.previewCloseOnEsc"
    [keyboardNavigation]="currentOptions?.previewKeyboardNavigation"
    [autoPlay]="currentOptions?.previewAutoPlay"
    [autoPlayInterval]="currentOptions?.previewAutoPlayInterval"
    [autoPlayPauseOnHover]="currentOptions?.previewAutoPlayPauseOnHover"
    [infinityMove]="currentOptions?.previewInfinityMove"
    [zoom]="currentOptions?.previewZoom"
    [zoomStep]="currentOptions?.previewZoomStep"
    [zoomMax]="currentOptions?.previewZoomMax"
    [zoomMin]="currentOptions?.previewZoomMin"
    [zoomInIcon]="currentOptions?.zoomInIcon"
    [zoomOutIcon]="currentOptions?.zoomOutIcon"
    [actions]="currentOptions?.actions"
    [rotate]="currentOptions?.rotate"
    [rotateLeftIcon]="currentOptions?.rotateLeftIcon"
    [rotateRightIcon]="currentOptions?.rotateRightIcon"
    (onClose)="onPreviewClose()"
    (onOpen)="onPreviewOpen()"
    (onActiveChange)="previewSelect($event)"
    [class.ngx-gallery-active]="previewEnabled"
    [showDownloadOnAction]="currentOptions?.previewShowDownload"
    (onDownload)="download($event)"
  ></ngx-gallery-preview>
</div>
